const PLATFORM_URL =
  process.env.REACT_APP_MAAZ_PLATFORM_URL || "http://localhost:5174";

export function goToPlatformHome() {
  localStorage.removeItem("token");
  localStorage.removeItem("student");
  window.location.replace(PLATFORM_URL);
}

export function productLogoutToPlatform() {
  localStorage.removeItem("token");
  localStorage.removeItem("student");
  window.location.replace(PLATFORM_URL);
}

export { PLATFORM_URL };
